import { Body } from '@workramp/ui';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  padding-top: ${({ theme }) => theme.spacing(10)}px;
  padding-bottom: ${({ theme }) => theme.spacing(10)}px;
`;

export const StyledBody = styled(Body)`
  max-width: ${({ theme }) => theme.spacing(120)}px;
`;
